/**
 * @Description 卡旺卡门店预估销售额组件
 */

import { FC } from 'react';
// import { useMethods } from '@lhb/hook';
// import { Form } from 'antd';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
interface EstimateSalesKWKProps {
  propertyItem: any;
  // form: any; // form组件实例
  // addressVal: any; // 地址组件的值
  // tiledFormDataRef: any; // 机会点动态表单，动态表单配置的组件平铺后的对象数组
};
const EstimateSalesKWKCom: FC<EstimateSalesKWKProps> = ({
  propertyItem,
  // form,
  // addressVal,
  // wholeFormData,
  // tiledFormDataRef,
}) => {
  const label = propertyItem?.anotherName || propertyItem?.name || '';

  // useEffect(() => {
  //   console.log(`wholeFormData`, wholeFormData);
  // }, [wholeFormData]);

  // const methods = useMethods({
  //   // 单选框选择后查找对应的影响因子的值
  //   findSelectedTargetVal: (identification: string, selectedId: number) => {
  //     const targetCom = tiledFormDataRef.current?.find((item) => item.identification === identification);
  //     console.log(`targetCom`, targetCom);
  //     if (targetCom) { // 对应的组件
  //       const { propertyConfigOptionVOList } = targetCom || {}; // 下拉框选项值
  //       if (isArray(propertyConfigOptionVOList) && propertyConfigOptionVOList.length) {
  //         const targetOption = propertyConfigOptionVOList.find((item) => item.id === selectedId);
  //         const { name } = targetOption || {}; // 下拉框选中的值
  //         const targetOptionVals = customEstimateSalesKWK[identification];
  //         const target = targetOptionVals?.find((item) => item.name === name);
  //         const { value } = target || {};
  //         return value || 0;
  //       }
  //     }
  //     return 0;
  //   }
  // });

  return (
    <V2FormInputNumber
      label={label || '门店预计销售额'}
      name={propertyItem.identification}
      config={{
        addonAfter: '元'
      }}
      placeholder='自动计算'
      precision={0}
      disabled
    />
  );
};

export default EstimateSalesKWKCom;
